import { Layout, Menu, Breadcrumb } from "antd";
import React from "react";
import { VideoPlayer } from "../../components";
import "./Play.less";
import { Link, useParams, NavLink, useHistory } from "react-router-dom";
import axios from "axios";
import { useState, useEffect } from "react";
import { LeftOutlined } from "@ant-design/icons";
import PlayNoIcon from "../../assets/images/play_no.png";
import PlayIcon from "../../assets/images/play.png";
import Feedback from "../../components/Feedback";
const { Header, Footer, Sider, Content } = Layout;
const { SubMenu } = Menu;
const rootSubmenuKeys = [
  "sub1",
  "sub2",
  "sub3",
  "sub4",
  "sub5",
  "sub6",
  "sub7",
];

const Play = (props) => {
  let { id } = useParams();
  const history = useHistory();
  const [videos, setVideos] = useState({
    7: {
      index: "1.1",
      description:
        "了解如何在官方平台下載到適用自己系統環境的FineReport以及從獲取到啟用的操作流程。",
      doclink: "https://help.fanruan.com/finereport-tw/doc-view-3918.html",
      video_title: "A00-00 安裝報表設計器",
    },
    10: {
      index: "1.2",
      description: "了解用於設計開發報表的設計器各區塊的基本功能。",
      doclink: "https://help.fanruan.com/finereport-tw/doc-view-3920.html",
      video_title: "A00-02 打開報表設計器",
    },
    18: {
      index: "2.1",
      description:
        "列式報表是最簡單的清單式列表，透過範例了解列式報表的製作步驟，並在此基礎上進行資料過濾和重複標題的進階設定。",
      doclink: "https://help.fanruan.com/finereport-tw/doc-view-3973.html",
      video_title: "A06-17 資料欄屬性-過濾",
    },
    11: {
      index: "2.2",
      description:
        "透過實際範例的製作步驟，學習將一張或多張報表嵌入主報表中從而實現報表各區塊格式不對齊的自由樣式。",
      doclink: "https://help.fanruan.com/finereport-tw/doc-view-3955.html",
      video_title: "A05-07 插入子報表",
    },
    12: {
      index: "2.3",
      description:
        "擴展後排序指在報表預覽時在線切換排序維度和排序順序，透過範例了解擴展後排序報表的製作步驟。",
      doclink: "https://help.fanruan.com/finereport-tw/doc-view-4550.html",
      video_title: "擴展後排序",
    },
    14: {
      index: "2.4",
      description:
        "了解如何透過條件屬性的設定實現報表樣式（如：背景、文字顏色、分頁）在不同條件下的顯示效果不同。",
      doclink: "https://help.fanruan.com/finereport-tw/doc-view-3995.html",
      video_title: "A09-00 條件屬性設定",
    },
    15: {
      index: "3.1",
      description:
        "相鄰連續分組可以將資料集中某個欄位的值相同且是連續的資料進行合併展示，透過範例瞭解相鄰連續分組報表的製作步驟。",
      doclink: "https://help.fanruan.com/finereport-tw/doc-view-3971.html",
      video_title: "A06-15 資料欄屬性-基本",
    },
    16: {
      index: "3.2",
      description:
        "按組分頁將一頁只顯示同一組的資料，便於分析，透過範例了解按組分頁報表的製作步驟",
      doclink: "https://help.fanruan.com/finereport-tw/doc-view-3970.html",
      video_title: "A06-14 其他-分頁",
    },
    17: {
      index: "3.3",
      description:
        "資料量大而欄位少的報表設定按列分欄後可以讓報表在預覽時縱向資料更少，多餘的資料在橫向展現，透過範例了解按列分欄報表的製作步驟。",
      doclink: "	https://help.fanruan.com/finereport-tw/doc-view-4030.html",
      video_title: "A11-12 範本-報表換列換欄",
    },
    19: {
      index: "4.1",
      description: "了解參數的三種設定方式和不同的適用場景。",
      doclink: "https://help.fanruan.com/finereport-tw/doc-view-4388.html",
      video_title: "A04-00 參數介紹",
    },
    20: {
      index: "4.2",
      description:
        "參數配合元件的設定即可實現在線的資料查詢效果，透過範例了解參數元件之一的下拉復選框多值查詢報表的製作步驟。",
      doclink: "https://help.fanruan.com/finereport-tw/doc-view-3938.html",
      video_title: "A04-05 下拉復選框元件",
    },
    21: {
      index: "4.3",
      description:
        "報表上鑽下鑽可以實現當前報表與其他報表發生關聯，透過挖掘上下層資料更好的進行分析，透過範例了解報表的製作步驟。",
      doclink: "https://help.fanruan.com/finereport-tw/doc-view-4010.html",
      video_title: "A10-01 網路報表",
    },
    22: {
      index: "5.1",
      description:
        "了解不同的圖表類型和其適用的場景以及設計方案，並透過範例操作知道圖表完整的製作流程。",
      doclink: "https://help.fanruan.com/finereport-tw/doc-view-4265.html",
      video_title: "圖表簡介",
    },
    23: {
      index: "5.2",
      description: "了解FineReport圖表類型之一的區域地圖的製作和樣式設定。",
      doclink: "https://help.fanruan.com/finereport-tw/doc-view-4121.html",
      video_title: "C00-19 區域地圖",
    },
    24: {
      index: "5.3",
      description:
        "了解圖表資料的兩種來源——資料集資料和儲存格資料的設定以及資料篩選的設定。",
      doclink: "https://help.fanruan.com/finereport-tw/doc-view-4134.html",
      video_title: "C01-00 資料集作為圖表資料來源",
    },
    25: {
      index: "5.4",
      description: "了解圖表不同樣式的設定從而實現豐富的展現效果。",
      doclink: "https://help.fanruan.com/finereport-tw/doc-view-4137.html",
      video_title: "C02-00 圖表標題",
    },
    26: {
      index: "5.5",
      description:
        "圖表聯動可以展現不同圖表間的關聯關係，更好的表現報表資料內容，透過範例了解圖表聯動的製作步驟。",
      doclink: "https://help.fanruan.com/finereport-tw/doc-view-4149.html",
      video_title: "C03-04 圖表聯動",
    },
    27: {
      index: "6.1",
      description:
        "列式填報是在列式報表的基礎上加入填報元件，實現資料的增加、刪除、修改。",
      doclink: "https://help.fanruan.com/finereport-tw/doc-view-4029.html",
      video_title: "A11-11 範本-報表填報屬性",
    },
    28: {
      index: "7.1",
      description:
        "了解決策報表的組件和佈局，並透過範例了解決策報表的製作步驟。",
      doclink: "https://help.fanruan.com/finereport-tw/doc-view-4468.html",
      video_title: "決策報表框架",
    },
  });
  const [videolist, setVideoList] = useState({
    1: [
      {
        title: "1.1 產品下載安裝",
        link: "7",
      },
      {
        title: "1.2 設計介面介紹",
        link: "10",
      },
    ],
    2: [
      {
        title: "2.1 列式報表",
        link: "18",
      },
      {
        title: "2.2 嵌入式主子報表",
        link: "11",
      },
      {
        title: "2.3 擴展後排序",
        link: "12",
      },
      {
        title: "2.4 條件屬性基礎",
        link: "14",
      },
    ],
    3: [
      {
        title: "3.1 相鄰連續分組",
        link: "15",
      },
      {
        title: "3.2 按組分頁",
        link: "16",
      },
      {
        title: "3.3 按列分欄",
        link: "17",
      },
    ],
    4: [
      {
        title: "4.1 參數設定",
        link: "19",
      },
      {
        title: "4.2 下拉復選框多值查詢",
        link: "20",
      },
      {
        title: "4.3 參數應用-報表鑽取",
        link: "21",
      },
    ],
    5: [
      {
        title: "5.1 圖表入門介紹",
        link: "22",
      },
      {
        title: "5.2 區域地圖",
        link: "23",
      },
      {
        title: "5.3 圖表資料設定",
        link: "24",
      },
      {
        title: "5.4 圖表樣式設定",
        link: "25",
      },
      {
        title: "5.5 圖表特效-聯動",
        link: "26",
      },
    ],
    6: [
      {
        title: "6.1 列式填報",
        link: "27",
      },
    ],
    7: [
      {
        title: "7.1 決策報表入門",
        link: "28",
      },
    ],
  });
  const [videotime, setVideTime] = useState({});
  const [list, setList] = useState(1);
  const [title, setTitle] = useState("basiclearning video");
  const [videodata, setVideoData] = useState({
    sources: {
      src: "",
      type: "video/mp4",
    },
  });
  const [openKeys, setOpenKeys] = React.useState([]);
  const option = {
    autoplay: true,
    controls: true,
    responsive: true,
    fluid: true,
  };
  useEffect(() => {
    async function fetchData() {
      const result = await axios({
        method: "get",
        url: process.env.REACT_APP_API + "/view/video",
        params: {
          id: id,
        },
      });
      const videodata = await result.data;
      return videodata;
    }
    fetchData().then((res) => {
      setVideoData({
        sources: {
          src: res.it618_videourl,
          type: "video/mp4",
        },
      });
      setList(res.it618_lid - 4);
      setTitle(res.it618_name);
      setOpenKeys(["sub" + (res.it618_lid - 4)]);
      document.title = res.it618_name
        ? res.it618_name
        : "FineReport 基礎學習路徑";
    });
  }, [id, list]);
  useEffect(() => {
    async function fetchData() {
      const result = await axios({
        method: "get",
        url: process.env.REACT_APP_API + "/view/tree",
      });
      const videolist = await result.data;
      return videolist;
    }
    fetchData().then((res) => {});
  }, [videolist]);

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    console.log(latestOpenKey);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };
  let dom = "";
  function handleClick() {
    history.push("/basiclearning");
  }
  if (videodata.sources.src !== "") {
    dom = (
      <div style={{ width: "1200px", margin: "0 auto" }}>
        <Feedback />
        <Layout style={{ fontSize: "16px" }}>
          <Sider
            width={300}
            className="site-layout-background"
            breakpoint="lg"
            collapsedWidth="0"
            onBreakpoint={(broken) => {}}
            onCollapse={(collapsed, type) => {}}
            style={{ height: "100%" }}
          >
            <div className="breadcrumb">
              <Breadcrumb separator=">">
                <Breadcrumb.Item>教學影片</Breadcrumb.Item>
                <Breadcrumb.Item>FineReport 10.0 基礎教學</Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <Menu
              mode="inline"
              style={{ height: "100%", borderRight: 0, fontSize: "16px" }}
              openKeys={openKeys}
              onOpenChange={onOpenChange}
              defaultSelectedKeys={videos[id]["index"]}
            >
              <SubMenu key="sub1" title="第1章 產品簡介">
                {videolist["1"].map((item, index) => {
                  return (
                    <Menu.Item
                      key={"1." + (index + 1)}
                      icon={
                        videos[id]["index"] === "1." + (index + 1) ? (
                          <img src={PlayIcon} alt="play" />
                        ) : (
                          <img src={PlayNoIcon} alt="play" />
                        )
                      }
                      style={{ paddingLeft: "24px" }}
                    >
                      <NavLink
                        to={{
                          pathname: `/basiclearning/${item.link}`,
                        }}
                      >
                        {item.title}
                      </NavLink>
                    </Menu.Item>
                  );
                })}
              </SubMenu>
              <SubMenu key="sub2" title="第2章 報表設計">
                {videolist["2"].map((item, index) => {
                  return (
                    <Menu.Item
                      key={"2." + (index + 1)}
                      icon={
                        videos[id]["index"] === "2." + (index + 1) ? (
                          <img src={PlayIcon} alt="play" />
                        ) : (
                          <img src={PlayNoIcon} alt="play" />
                        )
                      }
                      style={{ paddingLeft: "24px" }}
                    >
                      <Link
                        to={{
                          pathname: `/basiclearning/${item.link}`,
                        }}
                        replace
                      >
                        {item.title}
                      </Link>
                    </Menu.Item>
                  );
                })}
              </SubMenu>
              <SubMenu key="sub3" title="第3章 報表分組分頁分欄">
                {videolist["3"].map((item, index) => {
                  return (
                    <Menu.Item
                      key={"3." + (index + 1)}
                      icon={
                        videos[id]["index"] === "3." + (index + 1) ? (
                          <img src={PlayIcon} alt="play" />
                        ) : (
                          <img src={PlayNoIcon} alt="play" />
                        )
                      }
                      style={{ paddingLeft: "24px" }}
                    >
                      <NavLink
                        to={{
                          pathname: `/basiclearning/${item.link}`,
                        }}
                      >
                        {item.title}
                      </NavLink>
                    </Menu.Item>
                  );
                })}
              </SubMenu>
              <SubMenu key="sub4" title="第4章 參數介紹">
                {videolist["4"].map((item, index) => {
                  return (
                    <Menu.Item
                      key={"4." + (index + 1)}
                      icon={
                        videos[id]["index"] === "4." + (index + 1) ? (
                          <img src={PlayIcon} alt="play" />
                        ) : (
                          <img src={PlayNoIcon} alt="play" />
                        )
                      }
                      style={{ paddingLeft: "24px" }}
                    >
                      <NavLink
                        to={{
                          pathname: `/basiclearning/${item.link}`,
                        }}
                      >
                        {item.title}
                      </NavLink>
                    </Menu.Item>
                  );
                })}
              </SubMenu>
              <SubMenu key="sub5" title="第5章 圖表設計">
                {videolist["5"].map((item, index) => {
                  return (
                    <Menu.Item
                      key={"5." + (index + 1)}
                      icon={
                        videos[id]["index"] === "5." + (index + 1) ? (
                          <img src={PlayIcon} alt="play" />
                        ) : (
                          <img src={PlayNoIcon} alt="play" />
                        )
                      }
                      style={{ paddingLeft: "24px" }}
                    >
                      <NavLink
                        to={{
                          pathname: `/basiclearning/${item.link}`,
                        }}
                      >
                        {item.title}
                      </NavLink>
                    </Menu.Item>
                  );
                })}
              </SubMenu>
              <SubMenu key="sub6" title="第6章 填報應用">
                {videolist["6"].map((item, index) => {
                  return (
                    <Menu.Item
                      key={"6." + (index + 1)}
                      icon={
                        videos[id]["index"] === "6." + (index + 1) ? (
                          <img src={PlayIcon} alt="play" />
                        ) : (
                          <img src={PlayNoIcon} alt="play" />
                        )
                      }
                      style={{ paddingLeft: "24px" }}
                    >
                      <NavLink
                        to={{
                          pathname: `/basiclearning/${item.link}`,
                        }}
                      >
                        {item.title}
                      </NavLink>
                    </Menu.Item>
                  );
                })}
              </SubMenu>
              <SubMenu key="sub7" title="第7章 決策報表">
                {videolist["7"].map((item, index) => {
                  return (
                    <Menu.Item
                      key={"7." + (index + 1)}
                      icon={
                        videos[id]["index"] === "7." + (index + 1) ? (
                          <img src={PlayIcon} alt="play" />
                        ) : (
                          <img src={PlayNoIcon} alt="play" />
                        )
                      }
                      style={{ paddingLeft: "24px" }}
                    >
                      <NavLink
                        to={{
                          pathname: `/basiclearning/${item.link}`,
                        }}
                      >
                        {item.title}
                      </NavLink>
                    </Menu.Item>
                  );
                })}
              </SubMenu>
            </Menu>
          </Sider>
          <Layout style={{ paddingLeft: "40px" }} className="videoright">
            <Header className="videoheader">
              <h1>
                {videos[id] ? videos[id]["index"] : ""} {title}
              </h1>
              <div className="headerbg">
                <p>
                  課程簡介: {videos[id] ? videos[id]["description"] : "无简介"}
                </p>
              </div>
            </Header>
            <Content>
              {/* https://twmarket.obs.ap-southeast-3.myhuaweicloud.com/video/finemobile.mp4 */}
              <VideoPlayer {...videodata} {...option} />
            </Content>
            
            <div className="footer">
              <div onClick={handleClick} className="backhome">
                <LeftOutlined style={{ marginRight: "5px" }} />
                返回課程頁面
              </div>
              <div>
                幫助文檔：
                <a
                  href={
                    videos[id]
                      ? videos[id]["doclink"]
                      : "https://help.fanruan.com/finereport-tw"
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  {videos[id].video_title}
                </a>
              </div>
            </div>
          </Layout>
        </Layout>
      </div>
    );
  }
  return dom;
};

export default Play;
